<template>
  <div class="loginSucc" v-show="isShow">
    <div class="header">
      <div class="close-btn" @click="gotoLogin">
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-arrow-left-circle"></use>
        </svg>
      </div>
    </div>
    <div class="img">
      <img src="@/assets/images/ok.png">
    </div>
    <div class="text1">{{type===1?'注册成功':'修改成功'}}</div>
    <div class="text2">{{time}}s  后直接进入登录页面</div>
    <div class="user-layout-login">
      <el-button  type="primary" htmlType="submit" class="login-button" @click="gotoLogin">返回登录</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginSucc',
  data () {
    return {
      isShow: false,
      type: 1,
      time: 5
    }
  },
  mounted () {

  },
  created () {

  },
  methods: {
    show (isShow, type) {
      this.isShow = isShow
      if (this.isShow) {
        this.startTimer()
        this.type = type
      }
    },
    startTimer () {
      this.time = 5
      this.timer = setInterval(() => {
        this.time -= 1
        if (this.time <= 0) {
          this.gotoLogin()
        }
      }, 1000)
    },
    // 跳转登录
    gotoLogin () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.$emit('showLoginMsg')
    }
  }
}
</script>

<style lang="scss">
.loginSucc{
  width: 424px;
  height: 542px;
  background: url("~@/assets/images/bg2.png") no-repeat;
  background-size: contain;
  backdrop-filter: blur(5px);
  .header{
    position: relative;
    padding: 6px;
  }
  .title{
    font-size: 24px;
    font-family: Source Han Sans SC;
    color: #FFFFFF;
    text-shadow: 0px 3px 9px rgba(93, 204, 255, 1.0), 0px 2px 17px rgba(77, 199, 255, 1.0);
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .close-btn{
    position: absolute;
    right: 6px;
    top: 6px;
    width: 47px;
    height: 47px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid #4D9FC6;
    box-shadow: 1px 2px 9px 1px rgba(0, 0, 0, 0.1);
    border-radius: 0px 24px 1px 24px;
    line-height: 53px;
    svg {
      font-size: 24px;
      color: #49B8FF;
    }
  }
  .img {
    margin-top: 78px;
    margin-bottom: 20px;
  }
  .text1{
    font-size: 18px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-bottom: 2px;
  }
  .text2{
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #FFFFFF;
    margin-bottom: 40px;
  }
  .user-layout-login{
    padding: 0 40px;
    .el-input .el-input__inner {
      height: 40px;
      &:hover{
        border-color: #ddd !important;
      }
    }
    .el-input__prefix{
      top: 3px;
    }
    .login-button{
      width: 200px;
      height: 42px;
      border-radius: 6px;
      font-size: 18px !important;
    }
    svg{
      color: #aaa;
      font-size: 16px;
    }
  }
}
</style>
